import { render, staticRenderFns } from "./ProfileV2.vue?vue&type=template&id=b6851838&scoped=true&lang=pug"
import script from "./ProfileV2.vue?vue&type=script&lang=js"
export * from "./ProfileV2.vue?vue&type=script&lang=js"
import style0 from "./ProfileV2.vue?vue&type=style&index=0&id=b6851838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6851838",
  null
  
)

export default component.exports